import { EntitiesStatus } from 'common/types/Entities';

import { getStatusDisplayName } from './statusHelpers';

export const statusDropdownConfiguration = {
    id: 'status',
    label: 'Status',
    searchOptions: ['option1', 'option2'],
    isSearch: false,
    hasClear: false,
    checkBoxes: [
        {
            label: EntitiesStatus.ACTIVE
        },
        {
            label: EntitiesStatus.INACTIVE
        },
        {
            value: EntitiesStatus.NOACCESS,
            label: getStatusDisplayName(EntitiesStatus.NOACCESS)
        }
    ]
};
